var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login",staticStyle:{"margin":"30px"}},[_c('van-button',{attrs:{"color":"#437fee","loading":_vm.loading,"loading-text":"授权中..."},on:{"click":function($event){return _vm.clickMeds()}}},[_vm._v(" 华夏点击授权 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }